var render = function render(){var _vm=this,_c=_vm._self._c;return _c('re-navbar-top',{attrs:{"is-user-authenticated":_vm.isUserAuthenticated,"config":_vm.config,"navbar-items":_vm.navbarItems,"route-name":_vm.routeName,"title":_vm.title},on:{"onLogout":_vm.logout,"onGotoPortal":_vm.gotoPortal}})
}
var staticRenderFns = []

export { render, staticRenderFns }